import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ViewReasonComponent } from 'src/app/admin/components/view-reason/view-reason.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
@Component({
  selector: 'app-track-record',
  templateUrl: './track-record.component.html',
  styleUrls: ['./track-record.component.css'],
})
export class TrackRecordComponent implements OnInit {
  financialForm: FormGroup;
  private saveApi = environment.url + 'preincubation/trackrecord/save';
  private getApi = environment.url + 'preincubation/trackrecord/get?userId=';
  private deleteBestpracticesApi =
    environment.url + 'preincubation/bestpractices/Remove?id=';
  private deleteEventApi = environment.url + 'preincubation/event/Remove?id=';
  rows: { col1: string; col2: string }[];
  editRowId: number | null = null;
  bsLastValue;
  bsFromValue;
  bsToValue;
  applyLastMin;
  fromDateMin;
  fromDateMax;
  lastDateMin;
  /**
   * Initializes the TrackRecordComponent with required services and sets up the form and mobile query listener.
   * @param changeDetectorRef Reference to Angular's change detector for triggering change detection.
   * @param media Service to match media queries for responsive design.
   * @param fb FormBuilder service for creating reactive forms.
   * @param makeapi Service for making API calls.
   * @param getdata Service to retrieve values or data needed by the component.
   * @param notify Service for displaying notifications.
   * @param dialog Material dialog service for opening dialogs.
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    /**
     * Initialize the rows for the table by setting the first row values to empty strings.
     */
    this.rows = [{ col1: '', col2: '' }];
    /**
     * Set up the form with the required fields.
     */
    this.financialForm = this.fb.group({
      id: [0],
      trackRecordId: [0],
      applicationId: ['0'],
      bestpractices: this.fb.array([]),
      events: this.fb.array([]),
      iic: ['', [Validators.required]],
      iicbrief: [''],
    });
    /**
     * Set up the mobile query listener to detect changes in the mobile query.
     */
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  get setting() {
    return this.financialForm.controls;
  }
  get bestpractices() {
    return this.financialForm.get('bestpractices') as FormArray;
  }
  get events() {
    return this.financialForm.get('events') as FormArray;
  }
  roleName: any = '';
  /**
   * Angular lifecycle hook that is called after data-bound properties are initialized.
   * Retrieves the user's role from session storage and fetches data from the API.
   */
  ngOnInit(): void {
    // Get the user's role from session storage
    this.roleName = sessionStorage.getItem('role');

    // Fetch data from the API
    this.getDataApi();
  }

  getValue: any = {};
  Optionsonechecked;
  showForm: boolean = true;
  /**
   * Fetches the track record data from the API and populates the form and UI components
   * accordingly. Also sets the 'showForm' flag to true or false based on the 'edit'
   * value.
   */
  getDataApi() {
    this.events.clear();
    this.bestpractices.clear();
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        data.iic = data.iic.toString();
        this.showOptionsone(data.iic);
        if (data.responseStatus != 'Failed') {
          if (data.bestpractices && data.bestpractices.length > 0) {
            // Loop through the best practices array and add a row to the form for each item
            for (let i = 0; i < data.bestpractices.length; i++) {
              this.addBestpracticesRow();
            }
          }
          if (data.events && data.events.length > 0) {
            // Loop through the events array and add a row to the form for each item
            for (let i = 0; i < data.events.length; i++) {
              let val = data.events[i];
              if (val.date != undefined) {
                // Split the date string into day, month and year and convert it to a Date object
                let splitValue = val.date.split('/');
                let date: number = +splitValue[0];
                let month: number = +splitValue[1] - 1;
                let year: number = +splitValue[2];
                data.events[i].date = new Date(Date.UTC(year, month, date));
              }
              this.addEventsRow();
            }
          }
          this.financialForm.patchValue(data);
          // If the API response does not contain best practices data, add a row to the form array
          if (!data.bestpractices || data.bestpractices.length === 0) {
            this.addBestpracticesRow();
          }
          // If the API response does not contain events data, add a row to the form array
          if (!data.events || data.events.length === 0) {
            this.addEventsRow();
          }
          this.getdata.amizhthLoader('hide');
        }
      });
  }
  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  /**
   * Opens a dialog to display the reason for the given status.
   * @param status - The status object or value to show the reason for.
   */
  viewReasonBtn(status: any) {
    const dialogRef = this.dialog.open(ViewReasonComponent, {
      width: '390px',
      data: { _status: status },
    });

    // Handle the dialog's closed event
    dialogRef.afterClosed().subscribe((result) => {});
  }
  setStatus(event, key, value) {
    this.financialForm.controls[key].setValue(value);
  }

  userId = sessionStorage.getItem('userId');
  /**
   * Saves financial form data to the API.
   * Validates the form and processes date fields before submission.
   * Provides feedback on success or failure of the operation.
   * @param status - The status to be saved.
   */
  saveBtn(status) {
    // Retrieve the current form values
    let getform = this.financialForm.value;

    // Convert 'iic' field to boolean
    getform.iic = getform.iic === 'true';

    // Check if the form is invalid
    if (this.financialForm.invalid) {
      // Mark all fields as touched to show validation errors
      this.financialForm.markAllAsTouched();
      this.notify.notifyError('Form is Invalid !!');
    } else {
      // Process each event date if present
      if (getform.events.length > 0) {
        getform.events.forEach((element) => {
          if (element.date != undefined && typeof element.date === 'object') {
            let lastDate = moment(element.date).format('DD/MM/YYYY');
            element.date = lastDate;
          }
        });
      }

      // Add user ID to the form data
      getform.userid = this.userId;

      // Show loading indicator
      this.getdata.amizhthLoader('show');

      // Post the form data to the API
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        // Hide loading indicator
        this.getdata.amizhthLoader('hide');

        // Check API response status
        if (data.responseStatus == 'Success') {
          // Increment the step on success
          this.step++;
          this.notify.notifysuccess(data.responseMessage);
          // Refetch data to update the form
          this.getDataApi();
        } else {
          // Show error message on failure
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  step3 = 0;
  setStep3(index: number) {
    this.step3 = index;
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  /**
   * This function is called when the user types something in the input field for entering amount.
   * It removes any non-numeric characters from the input field.
   * @param event The event object containing information about the input field.
   */
  onAmountInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Check if the input field contains any non-numeric characters
    if (!/^\d*$/.test(value)) {
      // Remove any non-numeric characters from the input field
      input.value = value.replace(/[^\d]/g, '');
    }
  }
  /**
   * This function is called when the user clicks on the "Next" button.
   * It adds or removes validators from the form controls based on the current step.
   * If the user is on step 0, adds validators to the "IIC" form control.
   * If the user is on step 1, adds validators to the "Best Practices" form array.
   * If the user is on step 2, adds validators to the "Events" form array.
   * Then, calls the saveBtn function to save the form data.
   */
  nextStep() {
    if (this.step == 0) {
      // Add validators to the "IIC" form control if the user is on step 0
      this.financialForm.controls['iic'].setValidators([Validators.required]);
      this.financialForm.controls['iic'].updateValueAndValidity();
    } else {
      // Clear validators from the "IIC" form control if the user is on step 1 or 2
      this.financialForm.controls['iic'].clearValidators();
      this.financialForm.controls['iic'].updateValueAndValidity();
    }
    if (this.step == 1) {
      // Add validators to the "Best Practices" form array if the user is on step 1
      for (let i = 0; i < this.bestpractices.length; i++) {
        const item = this.bestpractices.at(i);
        item.get('bestpractice').setValidators([Validators.required]);
        item.get('bestpractice').updateValueAndValidity();
      }
    } else {
      // Clear validators from the "Best Practices" form array if the user is on step 2
      if (this.bestpractices.length > 0) {
        for (let i = 0; i < this.bestpractices.length; i++) {
          const item = this.bestpractices.at(i);
          item.get('bestpractice').clearValidators();
          item.get('bestpractice').updateValueAndValidity();
        }
      }
    }
    if (this.step == 2) {
      // Add validators to the "Events" form array if the user is on step 2
      for (let i = 0; i < this.events.length; i++) {
        const item = this.events.at(i);
        item.get('eventname').setValidators([Validators.required]);
        item.get('date').setValidators([Validators.required]);
        item.get('resource').setValidators([Validators.required]);
        item.get('measurableoutcome').setValidators([Validators.required]);
        item
          .get('noofparticipants')
          .setValidators([Validators.required, Validators.pattern('^[0-9]*$')]);
        item.get('topic').setValidators([Validators.required]);
        item.get('venue').setValidators([Validators.required]);
        item.get('fundedby').setValidators([Validators.required]);
        item
          .get('amount')
          .setValidators([Validators.required, Validators.pattern('^[0-9]*$')]);
        item.get('eventname').updateValueAndValidity();
        item.get('date').updateValueAndValidity();
        item.get('resource').updateValueAndValidity();
        item.get('measurableoutcome').updateValueAndValidity();
        item.get('noofparticipants').updateValueAndValidity();
        item.get('topic').updateValueAndValidity();
        item.get('venue').updateValueAndValidity();
        item.get('fundedby').updateValueAndValidity();
        item.get('amount').updateValueAndValidity();
      }
    } else {
      // Clear validators from the "Events" form array if the user is on step 0 or 1
      if (this.events.length > 0) {
        for (let i = 0; i < this.events.length; i++) {
          const item = this.events.at(i);
          item.get('eventname').clearValidators();
          item.get('date').clearValidators();
          item.get('resource').clearValidators();
          item.get('measurableoutcome').clearValidators();
          item.get('noofparticipants').clearValidators();
          item.get('topic').clearValidators();
          item.get('venue').clearValidators();
          item.get('fundedby').clearValidators();
          item.get('amount').clearValidators();
          item.get('eventname').updateValueAndValidity();
          item.get('date').updateValueAndValidity();
          item.get('resource').updateValueAndValidity();
          item.get('measurableoutcome').updateValueAndValidity();
          item.get('noofparticipants').updateValueAndValidity();
          item.get('topic').updateValueAndValidity();
          item.get('venue').updateValueAndValidity();
          item.get('fundedby').updateValueAndValidity();
          item.get('amount').updateValueAndValidity();
        }
      }
    }
    // Call the saveBtn function to save the form data
    this.saveBtn('save');
  }
  prevStep() {
    this.step--;
  }

  /**
   * Adds a new row to the "Best Practices" form array.
   * @param index The index at which to add the new row. If not specified, the new row is added at the end.
   */
  addBestpracticesRow(index?: number) {
    const practices = this.fb.group({
      id: 0,
      preinctrackrecordid: 0,
      bestpractice: [''],
    });
    if (index === undefined) {
      this.bestpractices.push(practices);
    } else {
      this.bestpractices.insert(index, practices);
    }
  }
  /**
   * Adds a new "Best Practice" row to the form array, limited to a maximum of 5 entries.
   * The new entry requires the 'bestpractice' field to be filled in.
   */
  addBestpracticesRow2() {
    let val = this.bestpractices.length; // Get the current number of best practices
    if (val <= 4) {
      // Limit the number of entries to 5
      const practices = this.fb.group({
        id: 0, // Initial ID value
        preinctrackrecordid: 0, // Initial track record ID
        bestpractice: ['', Validators.required], // 'bestpractice' field is required
      });
      this.bestpractices.push(practices); // Add the new practice to the form array
    }
  }
  /**
   * Deletes a row from the "Best Practices" form array.
   * If the id is not 0, makes an API call to delete the best practice.
   * If successful, removes the row at the specified index.
   * Adds a new row if the form array becomes empty after deletion.
   * @param index The index of the row to delete.
   * @param id The id of the best practice to delete.
   */
  deleteRow(index, id) {
    if (id != 0) {
      // Show the loading indicator
      this.getdata.amizhthLoader('show');

      // Make API call to delete the best practice
      this.makeapi
        .method(this.deleteBestpracticesApi + id, '', 'delete')
        .subscribe((data) => {
          // Hide the loading indicator
          this.getdata.amizhthLoader('hide');

          // Check if the API call was successful
          if (data.responseStatus != 'Failed') {
            // Remove the row with the given id from the array
            if (index == 0 && id != 0) {
              this.bestpractices.removeAt(id);
            }
          }

          // Remove the row from the array at the specified index
          if (id != 0) {
            this.bestpractices.removeAt(index);
            this.addBestpracticesRow(); // Add a new row if the array is empty
          }
        });
    } else if (index == 0 && id == 0) {
      // Remove the row from the array if both index and id are 0
      this.bestpractices.removeAt(index);
    } else if (index == 0 && id != 0) {
      // Remove the row from the array if index is 0 and id is not 0
      this.bestpractices.removeAt(index);
    } else {
      // Remove the row from the array if neither index nor id is 0
      this.bestpractices.removeAt(index);

      // Add a new row if the form array is empty
      if (index == 0) {
        this.addBestpracticesRow();
      }
    }
  }
  /**
   * Adds a new row to the events form array
   * @param index The index at which the new row should be added
   */
  addEventsRow(index?: number) {
    const eventsForm = this.fb.group({
      /**
       * The id of the event
       */
      id: 0,
      /**
       * The id of the pre incubation track record
       */
      preinctrackrecordid: 0,
      /**
       * The name of the event
       */
      eventname: [''],
      /**
       * The resource of the event
       */
      resource: [''],
      /**
       * The measurable outcome of the event
       */
      measurableoutcome: [''],
      /**
       * The number of participants in the event
       */
      noofparticipants: [''],
      /**
       * The topic of the event
       */
      topic: [''],
      /**
       * The date of the event
       */
      date: [''],
      /**
       * The venue of the event
       */
      venue: [''],
      /**
       * The funding source of the event
       */
      fundedby: [''],
      /**
       * The amount of the event
       */
      amount: [''],
    });
    if (index == undefined) {
      this.events.push(eventsForm);
    } else {
      this.events.insert(index, eventsForm);
    }
  }
  /**
   * Adds a new row to the events form array, limited to a maximum of 5 entries.
   * The new entry requires all fields to be filled in.
   * @param index The index at which the new row should be added
   */
  addEventsRow2(index?: number) {
    let val = this.events.length; // Get the current number of events
    if (val <= 4) {
      // Limit the number of entries to 5
      const eventsForm = this.fb.group({
        /**
         * The id of the event
         */
        id: 0,
        /**
         * The id of the pre incubation track record
         */
        preinctrackrecordid: 0,
        /**
         * The name of the event
         */
        eventname: ['', Validators.required],
        /**
         * The resource of the event
         */
        resource: ['', Validators.required],
        /**
         * The measurable outcome of the event
         */
        measurableoutcome: ['', Validators.required],
        /**
         * The number of participants in the event
         */
        noofparticipants: ['', Validators.required],
        /**
         * The topic of the event
         */
        topic: ['', Validators.required],
        /**
         * The date of the event
         */
        date: ['', Validators.required],
        /**
         * The venue of the event
         */
        venue: ['', Validators.required],
        /**
         * The funding source of the event
         */
        fundedby: ['', Validators.required],
        /**
         * The amount of the event
         */
        amount: ['', Validators.required],
      });
      this.events.push(eventsForm); // Add the new event to the form array
    }
  }
  /**
   * Deletes a row from the "Events" form array.
   * If the id is not 0, makes an API call to delete the event.
   * If successful, removes the row at the specified index.
   * Adds a new row if the form array becomes empty after deletion.
   * @param index The index of the row to delete.
   * @param id The id of the event to delete.
   */
  deleteRow2(index, id) {
    if (id != 0) {
      // Show the loading indicator
      this.getdata.amizhthLoader('show');

      // Make API call to delete the event
      this.makeapi
        .method(this.deleteEventApi + id, '', 'delete')
        .subscribe((data) => {
          // Hide the loading indicator
          this.getdata.amizhthLoader('hide');

          // Check if the API call was successful
          if (data.responseStatus != 'Failed') {
            // Remove the row with the given id from the array
            if (index == 0 && id != 0) {
              this.events.removeAt(id);
            }
          }

          // Remove the row from the array at the specified index
          if (id != 0) {
            this.events.removeAt(index);
          }
        });
    } else if (index == 0 && id == 0) {
      // Remove the row from the array if both index and id are 0
      this.events.removeAt(index);
    } else if (index == 0 && id != 0) {
      // Remove the row from the array if index is 0 and id is not 0
      this.events.removeAt(index);
    } else {
      // Remove the row from the array if neither index nor id is 0
      this.events.removeAt(index);

      // Add a new row if the form array is empty
      if (index == 0) {
        this.addEventsRow();
      }
    }
  }

  /**
   * Recursively marks all controls in the given form group as touched.
   * This is used to show all error messages at once.
   * @param formGroup The form group to mark all controls as touched.
   */
  markAllAsTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormArray) {
        // If the control is a form array, iterate over all its controls
        control.controls.forEach((group: FormGroup) =>
          this.markAllAsTouched(group)
        );
      } else {
        // If the control is not a form array, mark it as touched
        control?.markAsTouched();
      }
    });
  }
  /**
   * Handles the change event for the option selection.
   * Sets or clears validators for the 'iicbrief' control based on the event value.
   * @param event The change event indicating option selection ('true' or other values).
   */
  showOptionsone(event) {
    if (event == 'true') {
      // If the option selected is 'true', require the 'iicbrief' field
      this.financialForm.controls['iicbrief'].setValidators([
        Validators.required,
      ]);
    } else {
      // If the option selected is not 'true', clear the validators
      this.financialForm.controls['iicbrief'].clearValidators();
    }
    // Update the validity of the 'iicbrief' control
    this.financialForm.controls['iicbrief'].updateValueAndValidity();
  }
}
